import { createStyles, makeStyles, Theme } from "@material-ui/core/styles";
import { styleConstant } from "../../Constants";

export const useStyles = makeStyles((theme: Theme) => {
  const { siteNavigationComponentHeight } = styleConstant;

  return createStyles({
    homePageDetail_root: {
      gridColumnStart: "center",
      gridRowStart: "top",
      gridRowEnd: "bottom",
      zIndex: 0,
      height: "100%",
      paddingTop: siteNavigationComponentHeight,
      paddingLeft: "40px"
    }
  });
});
